<template>
  <!--
        作者：luoyiming
        时间：2019-10-25
        描述：权限-管理员列表
    -->
  <div class="user">
    <!--添加管理员-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick">添加规则</el-button>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="referee_grade_id" label="推荐等级">
              <template slot-scope="scope">
                <div class="green" >
                    {{scope.row.referee.name}}
                </div>
            </template>
          </el-table-column>
          <el-table-column prop="invited_grade_id" label="被推荐等级">
              <template slot-scope="scope">
                <div class="orange" >
                    {{scope.row.invited.name}}
                </div>
            </template>
          </el-table-column>

            <el-table-column prop="product" label="购买商品">
                <template slot-scope="scope">
                    <div class="img pr"  v-for="product in scope.row.productList"  :key="product.product_id">
                        <img v-img-url="product.product_image" width="100" height="100" alt="" />
                         <p class="text-ellipsis">{{ product.product_name }}</p>
                    </div>
                </template>
            </el-table-column>

            <el-table-column prop="num" label="有效次数"></el-table-column>
            <el-table-column prop="money" label="推荐奖励"></el-table-column>
         
          <el-table-column prop="create_time" label="添加时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small" >编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small" >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open="open_add" :gradeList="gradeList" :form="curModel"   @close="closeAdd"></Add>

    <Edit :open="open_edit" :gradeList="gradeList" :form="curModel"  @close="closeEdit"></Edit>

     <!--选择商品-->
    <ProductSelect :isproduct="isproduct" :excludeIds="excludeIds" :islist="islist" @closeDialog="closeProductDialogFunc($event)">产品列表弹出层</ProductSelect>
  </div>
</template>

<script>
import PlusApi from '@/api/plus.js';
import UserApi from '@/api/user.js';
import Add from './dialog/Add.vue';
import Edit from './dialog/Edit.vue';
import ProductSelect from '@/components/product/Product';
export default {
  components: {
    Add,
    Edit,
    ProductSelect
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*角色是否加载完成*/
      role_loading:true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        user: '',
        region: ''
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      curModel: {
        referee_grade_id: '',
        invited_grade_id:'',
        num:'',
        money:'',
        productList: []
      },
      /*等级列表*/
      gradeList:[],
       /*是否打开产品弹出层*/
      isproduct: false,
      /*商品需要去重的*/
      excludeIds: [],
      /*是否多选*/
      islist: false,
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();

    this.getAllGrade();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      PlusApi.rulesList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*获取等级*/
    getAllGrade() {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      UserApi.userlist(Params,true)
        .then(data => {
          self.role_loading = false;
         self.gradeList = data.data.grade;
        })
        .catch(error => {
          self.role_loading = false;
        });
    },

    /*打开添加*/
    addClick() {
      if(!this.role_loading){
         this.open_add=true;
      }
    },

    /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      if(e.type=='success'){
        this.getTableList();
      }
    },

    /*打开编辑*/
    editClick(row) {
        console.log(row);
      this.curModel=row;
      this.open_edit=true;
    },

    /*关闭添加*/
    closeEdit(e){
      this.open_edit=false;
      this.curModel = {
        referee_grade_id: '',
        invited_grade_id:'',
        num:'',
        money:'',
        productList: []
      };
      if(e.type=='success'){
        this.getTableList();
      }
    },


    /*商品选择列表弹出层*/
    openProduct(list, islist) {
      let arr = [];
      list.forEach(item => {
        arr.push(item.product_id);
      });
      this.excludeIds = arr;
      if (islist && typeof islist != 'undefined') {
        this.islist = true;
      } else {
        this.islist = false;
      }
      this.isproduct = true;
    },

    // /*商品选择关闭弹窗*/
    closeProductDialogFunc(e) {
      if (this.curModel == null) {
        return;
      }
      this.isproduct = false;
      let arr = [];
      if(e.params){
          e.params.forEach(item=>{
              console.log(item);
              arr.push({ product_id: item.product_id, product_image: item.image,product_name: item.product_name });
          });
      }
      console.log(arr);
      if (e.type == 'success') {
        if (this.islist) {
          this.curModel.productList= this.curModel.productList.concat(arr);
        } else {
          this.curModel.productList.push(arr);
        } 
      }
    },

    deleteFunc(index){
       /*删除商品*/
      this.curModel.productList.splice(index, 1);
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          PlusApi.rulesDelete(
            {
              agent_rules_id: row.agent_rules_id
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '删除成功',
                  type: 'success'
                });
                //刷新页面
                self.getTableList();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/agent/setting/part/Advance.vue